<template>
  <span>
    <!-- ▼掲載期間見出し -->
    <scout-period-bar
      :first-date="contract.firstDate"
      :last-date="contract.lastDate"
      :scout-limit="contract.scoutLimit"
      :sent-scout-amount="contract.sentScoutAmount"
      :reserved-scout-first-send-amount="contract.reservedScoutFirstSendAmount"
    />
    <!-- ▲掲載期間見出し -->
    <div class="boss-contractperiod-wrap">
      <!-- ▼求人掲載リスト -->
      <div class="boss-scoutandlike-container">
        <div class="boss-scoutandlike-wrap">
          <ul class="boss-scoutandlike-list">
            <template v-for="(job, i) in contract.jobs">
              <scout-job-topics
                :key="i"
                :job="job"
                :contract-id="contractId"
                :associated-user-count-with-job="getAssociatedUserCountWithJob(job.id)"
              />
            </template>
          </ul>
        </div>
      </div>
      <!-- ▲求人掲載リスト -->
    </div>
  </span>
</template>

<script>
import ScoutPeriodBar from '@/components/molecules/ScoutPeriodBar'
import ScoutJobTopics from '@/components/organisms/ScoutJobTopics'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  components: { ScoutPeriodBar, ScoutJobTopics },
  props: {
    contractId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      associatedUserCountWithJobs: []
    }
  },
  computed: {
    contract () {
      return this.contracts(this.contractId)
    },
    ...mapGetters('contracts', [
      'contracts'
    ])
  },
  created () {
    this.fetchJobs().then(response => {
      this.$set(this, 'associatedUserCountWithJobs', response.data)
      this.setSearchConditionId()
    })
  },
  methods: {
    fetchJobs () {
      return this.$http.secured.get(`/company/contracts/${this.contractId}/jobs`)
    },
    getAssociatedUserCountWithJob (jobId) {
      return _.defaultTo(_.find(this.associatedUserCountWithJobs, { jobId: Number(jobId) }), {})
    },
    setSearchConditionId () {
      this.associatedUserCountWithJobs.forEach(associatedUserCountWithJob => {
        associatedUserCountWithJob.latestSearchConditionId && this.$store.dispatch('contracts/setSearchConditionId', {
          value: associatedUserCountWithJob.latestSearchConditionId,
          jobId: associatedUserCountWithJob.jobId
        })
      })
    }
  }
}
</script>
